import React from 'react';
import { AlertTriangle, XCircle, CheckCircle, Info } from 'lucide-react';

const ICON_MAP = {
  warning: AlertTriangle,
  error: XCircle,
  success: CheckCircle,
  info: Info,
};

const STYLE_MAP = {
  warning: 'bg-amber-500/10 text-amber-400 border-amber-500/20',
  error: 'bg-red-500/10 text-red-400 border-red-500/20',
  success: 'bg-emerald-500/10 text-emerald-400 border-emerald-500/20',
  info: 'bg-blue-500/10 text-blue-400 border-blue-500/20',
};

export default function AlertSystem({ alerts }) {
  if (!alerts || alerts.length === 0) return null;

  return (
    <div className="px-4 py-2 flex flex-wrap gap-2 border-b border-white/5 bg-slate-900/30" data-testid="alert-system">
      {alerts.map((alert, i) => {
        const Icon = ICON_MAP[alert.type] || Info;
        const style = STYLE_MAP[alert.type] || STYLE_MAP.info;

        return (
          <div
            key={i}
            data-testid={`alert-${i}`}
            className={`flex items-center gap-2 px-3 py-1.5 rounded-md text-xs font-medium border ${style} transition-all duration-300`}
          >
            <Icon className="w-3.5 h-3.5 shrink-0" />
            <span>{alert.message}</span>
          </div>
        );
      })}
    </div>
  );
}
